export const ADD_ITEM_TO_SHOPPING = "ADD_ITEM_TO_SHOPPING";

export const addItemToShoppingCart = (itemId, amount) => {
    return (dispatch, getState) => {
        dispatch({type: ADD_ITEM_TO_SHOPPING, itemId, amount})
    }
}